exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-diff {\n  color: #60b515; }\n\n.diff {\n  color: #c92100; }\n\n.cont {\n  display: -ms-flexbox;\n  display: flex; }\n\n.warn-cont {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .warn-cont span {\n    line-height: 24px; }\n\n.warn {\n  color: #e62700;\n  font-size: 16px !important; }\n\n.busy *:not(.submit-warn) {\n  opacity: 0.5;\n  z-index: 9999; }\n\n.overlay {\n  position: relative; }\n\nimg.busySpin {\n  margin-top: 48px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 96px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-voids-recon/form-voids-recon.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/form-voids-recon/form-voids-recon.component.scss
// module chunks = main